import EndUrls from "../endUrls";
import { patchService } from "../services";

export const changeStatus = async ({ id, status }) => {
   try {
      const data = {
         id: id,
         is_active: status,
         model_id: 10,
         action_id: 2,
      };

      const { data: res } = await patchService(EndUrls.changeLocationStatus, data, true);

      if (res.statusCode === 200) {
         return res;
      } else {
         throw new Error(res.message);
      }
   } catch (error) {
      throw error;
   }
};
